import AuditApi from "../../api/auditApi";
import { urlContexts } from "../../constants";

const token = () => {
  return sessionStorage.getItem('REDIRECT::INFO') ?? new URLSearchParams(window.location.search).get('token') ?? '';
};

export const getAuditByTenant = async (tenantid: string) => {
  const { data } = await AuditApi.get(
    `${process.env.REACT_APP_AUDIT_HOST || process.env.REACT_APP_BACKEND_HOST}/${urlContexts.auditory}/rest/1.0/audit/dashboard?limit=${4}&offset=${0}&tenantId=${tenantid}`
  );

  return data;
};

export const postAudit = async (body: any) => {
  const { data } = await AuditApi.post(
    `${process.env.REACT_APP_AUDIT_HOST || process.env.REACT_APP_BACKEND_HOST}/${urlContexts.auditory}/rest/1.0/audit`,
    body,
    {
      headers: {
        Authorization: `Bearer ${token()}`,
      }
    }
  );

  return data;
};

export const postAuditReport = async (body: any, language: string, offset?: string, limit?: string) => {
  const { data } = await AuditApi.post(
    `${process.env.REACT_APP_AUDIT_HOST || process.env.REACT_APP_BACKEND_HOST}/${urlContexts.auditory}/rest/1.0/audit/report${
      !!offset ? ('?offset=' + offset) : ''}${(!!offset && !!limit) ? ('&limit=' + limit) : ''}`,
    {
      ...body,
      startCreationDate: `${body.startCreationDate?.slice(0,11)}00:00:00.000`,
      endCreationDate: `${body.endCreationDate?.slice(0,11)}23:59:59.000`,
    },
    {
      headers: {
        Authorization: `Bearer ${token()}`,
        lang: language,
      }
    }
  );

  return data;
};

export const exportAuditReportPdf = async (body: any, language: string) => {
  const { data } = await AuditApi.post(
    `${process.env.REACT_APP_AUDIT_HOST || process.env.REACT_APP_BACKEND_HOST}/${urlContexts.auditory}/rest/1.0/audit/report/pdf`,
    body,
    {
      headers: {
        Authorization: `Bearer ${token()}`,
        lang: language,
      },
      responseType: 'blob',
    }
  );

  return data;
};

export const exportAuditReportCsv = async (body: any, language: string) => {
  const { data } = await AuditApi.post(
    `${process.env.REACT_APP_AUDIT_HOST || process.env.REACT_APP_BACKEND_HOST}/${urlContexts.auditory}/rest/1.0/audit/report/csv`,
    body,
    {
      headers: {
        Authorization: `Bearer ${token()}`,
        lang: language,
      }
    }
  );

  return data;
};

export const getAuditReportDetail = async (eventId: any, language: string) => {
  const { data } = await AuditApi.get(
    `${process.env.REACT_APP_AUDIT_HOST || process.env.REACT_APP_BACKEND_HOST}/${urlContexts.auditory}/rest/1.0/audit/report/${eventId}`,
    {
      headers: {
        Authorization: `Bearer ${token()}`,
        lang: language,
      }
    }
  );

  return data;
};

export const exportAuditDetailPdf = async (eventId: any, language: string) => {
  const { data } = await AuditApi.get(
    `${process.env.REACT_APP_AUDIT_HOST || process.env.REACT_APP_BACKEND_HOST}/${urlContexts.auditory}/rest/1.0/audit/report/pdf/${eventId}`,
    {
      headers: {
        Authorization: `Bearer ${token()}`,
        lang: language,
      },
      responseType: 'blob',
    }
  );

  return data;
};
